// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__3ZkGI","GradientAnimation":"App_GradientAnimation__1UjH1"};